/**
 * designImages — where a design's image slot is served from (the pass-image
 * CDN). One helper for every canvas host: the studio editor, its generate
 * step and the pass page preview.
 */
import type { PassDesign } from '@insurwiz/wallet-core';

import type { DesignImageSlot } from '../types';

const PASS_CDN_BASE_URL = import.meta.env.VITE_PASS_CDN_BASE_URL as string | undefined;

export function designImageUrl(design: PassDesign, slot: DesignImageSlot): string | null {
  const ref = design.images[slot];
  if (!ref || !PASS_CDN_BASE_URL) return null;
  // The renderer derives @2x by suffix; the preview loads the @2x sibling.
  return `${PASS_CDN_BASE_URL}/${ref.s3KeyBase}@2x.png`;
}
